import React, {memo} from 'react';

import styles from './Loading.module.less';

export default memo(({ offset = 0 }) => {
  return (
    <div className={styles.Loading} style={{ paddingTop: `${200 + offset}px` }}>
      <img src={require('./loading.gif')} alt="" />
    </div>
  );
});
